import { createSelector } from 'reselect'

export let managerInfo = createSelector([], () => {
	return {
		avatar: 'https://lumand.com/uploads/prod/managers/Lisa/Lisa.jpeg'
	  , name: "Lisa"
	  , phone: "777-777-777"
	  , email: "lisa@somwhere.com"
	}
})



// WEBPACK FOOTER //
// ./src/selectors/manager.js